module.exports = __webpack_public_path__ + "img/loginWithApp.8b9aa44b.png";